import React, { Fragment } from 'react';
import TextField from './TextField';
import { Validation } from '../../../services';

var ShareholderIndividualFieldGroup = function ShareholderIndividualFieldGroup(_ref) {
  var name = _ref.name;
  return React.createElement(Fragment, null, React.createElement(TextField, {
    label: 'First Name',
    name: "".concat(name, ".first_name"),
    placeholder: 'Enter First Name'
  }), React.createElement(TextField, {
    label: 'Last Name',
    name: "".concat(name, ".last_name"),
    placeholder: 'Enter Last Name'
  }), React.createElement(TextField, {
    label: '% of equity',
    type: 'number',
    name: "".concat(name, ".participation_percentage"),
    placeholder: 'Enter % of equity',
    validate: [Validation.percentageRange]
  }));
};

export default ShareholderIndividualFieldGroup;